<script>
const cookieName = 'show_deleted_account_lightbox';
export default {
    props: ['user','deleteAccountUrl'],

    data: function(){
        return  {
            waitingServerResponse: false,
        };
    },

    methods: {
        onDelete: function(event){
            event.preventDefault()

            if(!this.waitingServerResponse) {
                this.waitingServerResponse = true;
                this.$http.post(
                    this.deleteAccountUrl,
                    {
                        user: this.user
                    },
                    {   headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then((response) => {
                    if(response.status==204){
                        //remove cookie
                        this.$cookies.set(cookieName, '1', null, null, locations.cookie_domain);
                        window.location.replace('https://'+window.location.hostname);
                    }
                }).catch((error)=>{
                    console.error(error);
                }).finally(() => {
                    this.waitingServerResponse = false;
                });
            }
        }
    }
};

</script>
